import React, { useEffect, useState } from 'react';
import ItemOrderDetail from './ItemOrderDetail';
import {
  ListOrderDetailWrapper,
  ListDetailBackground,
  ListDetailLayout
} from './ListOrderDetail.style';
import { CloseIcon } from 'components/ui-kits/Icon';
import {
  formatDollar,
  getOrderDateAndTime,
  renderQuantityWithUnit
} from 'utils';
import type { RevenueData } from 'types/Revenue';

type Props = {
  orderNumber: string;
  dateAndTime: string | undefined;
  name: any;
  subTotalPrice: number;
  taxRevenues: number;
  operationCosts: number;
  itemsOriginal: RevenueData['orders'][number]['itemsOriginal'];
  refund: number | null;
  refundCost: number;
  deliveryFee: number;
  netRevenues: number;
  isClosePanelRight: (status: boolean) => void;
};

const ListOrderDetail = ({
  orderNumber,
  dateAndTime,
  name,
  subTotalPrice,
  taxRevenues,
  operationCosts,
  itemsOriginal,
  refund,
  refundCost,
  deliveryFee,
  netRevenues,
  isClosePanelRight
}: Props) => {
  const [isClose, setIsClose] = useState(false);
  const { date, time } = getOrderDateAndTime(dateAndTime);

  useEffect(() => {
    document.body.classList.add('not-scroll-body');
    return () => {
      document.body.classList.remove('not-scroll-body');
    };
  }, [isClose]);

  const handleCloseModal = () => {
    setIsClose(isClose);
    isClosePanelRight?.(false);
  };

  return (
    <ListOrderDetailWrapper>
      <ListDetailBackground onClick={handleCloseModal} />
      <ListDetailLayout>
        <div className="headWrapper">
          <div className="orderNumber">Numéro de commande {orderNumber}</div>
          <div className="closeButton" onClick={handleCloseModal}>
            <CloseIcon />
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th className="timeOrder">Date et heure</th>
              <th>
                <div className="timeWrapper">
                  <div className="hour">{time}</div>
                  <div className="day">{date}</div>
                </div>
              </th>
              <th className="name">Nom</th>
              <th className="dylanKose">{name}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="headerTitle" colSpan={3}>
                Produits
              </td>
              <td className="headerTitle qty">Qté.</td>
              <td className="headerTitle priceWrapper">Prix</td>
            </tr>
            {itemsOriginal.length ? (
              itemsOriginal.map((item) => {
                const qty = item.isSellWithUnits
                  ? renderQuantityWithUnit(
                      item.quantity,
                      item.quantityProductSoldByWeight,
                      item.unit
                    )
                  : item.quantity;

                return (
                  <ItemOrderDetail
                    key={item.name}
                    mainItem={item.name}
                    qty={qty}
                    price={`${formatDollar(item.price)}€`}
                    subItem={item.options?.map((subItem, index) => (
                      <div key={`${subItem.name} + ${index}`}>
                        {subItem.name}
                      </div>
                    ))}
                    subQty={item.options?.map((subQty, index) => (
                      <div key={`${subQty.quantity} + ${index}`}>
                        {subQty.quantity}
                      </div>
                    ))}
                    subPrice={item.options?.map((subPrice, index) => (
                      <div
                        key={`${subPrice.price} + ${index}`}>{`${formatDollar(
                        subPrice.price
                      )}€`}</div>
                    ))}
                  />
                );
              })
            ) : (
              <tr>
                <td></td>
              </tr>
            )}
            <tr>
              <td colSpan={4}>
                <div className="totalLabel">Sous-total (TTC)</div>
                {deliveryFee ? (
                  <div className="totalLabel">Frais de livraison</div>
                ) : null}
                <div className="totalLabel">Total (TTC)</div>
                <div className="totalLabel">Frais de service</div>
                {refund && (
                  <>
                    <div className="totalLabel">Remboursement</div>
                    <div className="totalLabel">
                      Frais de remboursement Achil
                    </div>
                  </>
                )}
                <div className="totalLabel netPayment">Revenus net</div>
              </td>
              <td>
                <div className="totalPrice">
                  {formatDollar(subTotalPrice || 0)}€
                </div>
                {deliveryFee ? (
                  <div className="totalPrice">{formatDollar(deliveryFee)}€</div>
                ) : null}
                <div className="totalPrice">
                  {formatDollar(taxRevenues || 0)}€
                </div>
                <div className="totalPrice">
                  {formatDollar(operationCosts || 0)}€
                </div>
                {refund && (
                  <div className="totalPrice">{formatDollar(refund)}€</div>
                )}
                {refund && refundCost !== undefined && (
                  <div className="totalPrice">{formatDollar(refundCost)}€</div>
                )}

                <div className="totalPrice netPayment">
                  {formatDollar(netRevenues || 0)}€
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ListDetailLayout>
    </ListOrderDetailWrapper>
  );
};

export default ListOrderDetail;
